// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import "./navbar.css";

// export class Navbar extends Component {
//   render() {
//     return (
//       <nav>
//         <ul>
//           <li>
//             <Link to="/">Home</Link>
//           </li>
//           <li>
//             <Link to="/india">India</Link>
//           </li>
//           <li>
//             <Link to="/countries">Countries</Link>
//           </li>
//           <li>
//             <Link to="/countrieschart">Chart</Link>
//           </li>
//         </ul>
//       </nav>
//     );
//   }
// }

// export default Navbar;
import React from "react";
import { NavLink } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import { Typography } from "@material-ui/core";
import { Paper } from "@material-ui/core";
import styles from "./navbar.module.css";
import Icon from "@material-ui/core/Icon";

function Navbar() {
  return (
    <AppBar position="sticky">
      <Paper className={styles.headerStyle}>
        <Typography
          variant="h5"
          style={{
            fontFamily: "Rajdhani",
            textAlign: "center",
            width: "100%",
            backgroundColor: "#3C245B",
            fontWeight: "500",
            padding: "10px",
            color: "#fff",
          }}
        >
          Covid 19 Tracker
        </Typography>
        <div className={styles.navStyle} style={{ textDecoration: "none" }}>
          <div>
            <NavLink to={"/Countries"} activeClassName={styles.active}>
              <Icon>language</Icon>
            </NavLink>
          </div>
          <div>
            <NavLink
              to={"/usa"}
              activeClassName={styles.active}
              style={{ textDecoration: "none" }}
            >
              <h5>USA</h5>
            </NavLink>
          </div>
          <div>
            <NavLink
              to={"/canada"}
              activeClassName={styles.active}
              style={{ textDecoration: "none" }}
            >
              <h5>CANADA</h5>
            </NavLink>
          </div>
          <div>
            <NavLink
              to={"/India"}
              activeClassName={styles.active}
              style={{ textDecoration: "none" }}
            >
              <h5>INDIA</h5>
            </NavLink>
          </div>
          <div>
            <NavLink to={"/Info"} activeClassName={styles.active}>
              <Icon>assignment</Icon>
            </NavLink>
          </div>
          <div>
            <NavLink to={"/thanks"} activeClassName={styles.active}>
              <Icon>favorite</Icon>
            </NavLink>
          </div>
        </div>
      </Paper>
    </AppBar>
  );
}

export default Navbar;
//    < a href = "https://www.freepik.com/free-photos-vectors/infographic" > Infographic vector created by pikisuperstar - www.freepik.com</a >
